import React from 'react';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

import footerNavigationItems from '@config/data/footerNavigationItems.json';

export default function FooterNavigation(): React.JSX.Element {
  return (
    <Box className="flex justify-between gap-x-7 max-md:gap-x-0">
      {footerNavigationItems.map((item) => (
        <div key={item.href}>
          <Link
            href={item.href}
            target="_blank"
            className="text-xs max-md:text-[11px] text-gray-04 rf-hover-text"
            underline="none"
          >
            {item.label}
          </Link>
        </div>
      ))}
    </Box>
  );
}
